/*eslint-disable  @typescript-eslint/ban-ts-comment, unicorn/prefer-top-level-await,  unicorn/prefer-module  */
import { createRoot } from 'react-dom/client';

import { IS_STAGING } from './features/myPage/constants/general';

// Purpose of bootstrapping all file into app.tsx is to
// make sure remoteEntry.js loaded and parsed BEFORE the main app's code.
// @ts-expect-error
import('./App.tsx').then(({ default: App }) => {
  const rootElement = document.querySelector('#root');

  if (rootElement) {
    const root = createRoot(rootElement);

    if (IS_STAGING) {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex';
      document.head.append(meta);
    }

    const renderApp = () => {
      root.render(<App />);
    };

    // @ts-expect-error
    if (module.hot) {
      // @ts-expect-error
      module.hot.accept('./App.tsx', renderApp);
    }

    renderApp();
  }
});
